import { Record } from 'immutable';

export class MessageDialogMessage extends new Record({
  type: undefined,
  message: undefined,
}) {
  constructor(type, message) {
    super({ type, message });
  }
}
